import WebsiteBehaviors from "../website-behaviors/index.js";

class SciHubPdf extends WebsiteBehaviors {
	identifier() {
		return "SciHubPdf";
	}

	static isPDF() {
		return true;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return window.top !== window.self && location.host.endsWith("sci-hub.se");
	}

	shouldFrameTakeControl() {
		return true;
	}
}

export default SciHubPdf;
